<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
      v-el-drag-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    top="5vh"
    center
    width="60%"
  >
    <dialog-header slot="title" :title="$t('carMonitor.terminalBatch.addObdTask')" @close="closeDialog" />
     <div style="height: 70vh">
      <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
        <vue-linetitle 
        :title="$t('public.taskInformation')"
        :icon-config="{icon: 'taskInformation'}">
        <el-row type="flex" justify="start" align="top">
            <el-col :span="12">
            <el-form
                ref="taskform"
                :rules="rulesCenter"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')"
            >
                <el-form-item :label="$t('carMonitor.terminalBatch.taskName')+'：'" prop="operationname">
                <el-input
                    v-model="formInfo.operationname"
                    :placeholder="$t('carMonitor.terminalBatch.taskName')"
                    clearable
                />
                </el-form-item>
                <el-form-item style="margin-bottom: 0 !important" :label="$t('carMonitor.terminalBatch.remark')+'：'">
                <el-input
                    v-model.trim="formInfo.remark"
                    :placeholder="$t('carMonitor.terminalBatch.remark')"
                />
                </el-form-item>
            </el-form>
            </el-col>
        </el-row>
        </vue-linetitle>
        <vue-linetitle 
        :title="$t('carMonitor.terminalBatch.upgrade')"
        :icon-config="{icon: 'upgrade'}">
        <div style="padding: 10px 20px 20px 20px">
            <el-radio v-model="isHistory" :label="false">
            <span>{{ $t('carMonitor.terminalBatch.createUpgrade') }}</span>
            </el-radio>
            <el-radio v-model="isHistory" :label="true">
            <span>{{ $t('carMonitor.terminalBatch.HistoricalUpgrade') }}</span>
            </el-radio>
        </div>
        <el-row v-show="!isHistory" type="flex" justify="start">
            <el-col :span="9">
            <el-form
                ref="fileName"
                label-position="'right'"
                :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')"
                :model="formInfo"
                :rules="rulesCenter"
            >
                <el-form-item :label="$t('carMonitor.terminalBatch.uploadFiles')+'：'" prop="fileName">
                  <el-input v-model="formInfo.fileName" disabled clearable />
                </el-form-item>
            </el-form>
            </el-col>
            <el-col :span="3" type="flex" align="end">
            <el-upload
                ref="upload"
                :headers="{ Authorization: token }"
                :auto-upload="false"
                :show-file-list="false"
                :file-list="fileList"
                :multiple="true"
                :before-upload="beforeupload"
                :on-change="fileChange"
                :on-success="fileSuccess"
                :on-error="fileError"
                :action="baseApi +'/terminalcommandpacket/uploadFile'"
            >
                <el-button type="primary">{{ $t('carMonitor.terminalCommand.browse') }}</el-button>
            </el-upload>
            </el-col>
            <el-col :span="12">
            <el-form
                ref="commandForm"
                label-position="'right'"
                label-width="100px"
                :rules="rulesCenter"
                :model="commandInfo"
            >
                <el-form-item :label="$t('carMonitor.terminalBatch.version')+'：'" prop="fileVersion">
                  <el-input v-model="commandInfo.fileVersion" clearable />
                </el-form-item>
            </el-form>
            </el-col>
        </el-row>
        <el-row type="flex" justify="start">
          <el-col :span="12" v-show="!isHistory">
            <el-form label-position="'right'" :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')" :model="commandInfo">
                <el-form-item :label="$t('carMonitor.terminalBatch.versionDescription')+'：'">
                  <el-input v-model="commandInfo.remark" clearable />
                </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form label-position="'right'" label-width="100px" :model="commandInfo" :rules="rulesCenter">
                <el-form-item :label="$t('carMonitor.terminalBatch.sjtype')+'：'" prop="type">
                  <el-select
                      v-model="commandInfo.type"
                      :placeholder="$t('carMonitor.terminalBatch.sjtype')"
                      filterable
                      clearable
                  >
                      <el-option
                      v-for="(item,index) in sjList"
                      :key="index"
                      :label="item.text"
                      :value="item.value"
                      />
                  </el-select>
                </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-show="isHistory" type="flex" justify="start">
            <el-col :span="12">
            <el-form
                label-position="'right'"
                :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')"
                :rules="rulesCenter"
                :model="commandInfo"
                ref="history"
            >
                <el-form-item :label="$t('carMonitor.terminalBatch.historicalVersion')+'：'" prop="historicalVersion">
                <el-select
                    v-model="commandInfo.historicalVersion"
                    :placeholder="$t('carMonitor.terminalBatch.historicalVersion')"
                    filterable
                    clearable
                >
                    <el-option
                    v-for="(item,index) in historyVersionList"
                    :key="index"
                    :label="item.historicalVersion"
                    :value="item.historicalVersion"
                    />
                </el-select>
                </el-form-item>
            </el-form>
            </el-col>
        </el-row>
        </vue-linetitle>
        <vue-linetitle :title="$t('public.commandVehicle')" :icon-config="{icon: 'commandVehicle'}">
        <el-row type="flex" justify="start" align="top">
            <el-col :span="12">
            <el-form
                ref="carform"
                :rules="rulesCenter"
                :model="formInfo"
                :label-position="'right'"
                :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')"
            >
                <el-form-item :label="$t('carMonitor.terminalBatch.selectObd')+'：'" prop="car">
                <div style="position:relative;">
                    <div
                    style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:999;cursor:pointer"
                    @click="selectCarVisibles=true"
                    />
                    <div class="fl car-tag">
                    <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
                        <el-tag
                        style="margin: 0 5px"
                        v-for="(tag,index) in selectCarList"
                        :key="index"
                        closable
                        effect="plain"
                        :disable-transitions="false"
                        @close="handleClose(tag)"
                        >
                        <span>{{ tag.barcode }}</span>
                        </el-tag>
                    </el-scrollbar>
                    </div>
                </div>
                </el-form-item>
            </el-form>
            </el-col>
            <el-col :span="3" style="margin-left: 20px" type="flex" align="start">
            <el-button type="primary" @click="selectCarVisibles=true">
                <svg-icon icon-class="icon-add" />
                {{ $t('public.chose') }}
            </el-button>
            </el-col>
            <el-col :span="2" type="flex" justify="center" align="center">
            <el-button type="primary" @click="importVisible=true">
                <svg-icon icon-class="icon-import" />
                {{ $t('carMonitor.terminalBatch.import') }}
            </el-button>
            </el-col>
        </el-row>
        </vue-linetitle>
    </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="dialog-cancel"
        type="primary"
        @click="handleCancel"
      >{{ $t('carMonitor.terminalBatch.cancleBtn') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('carMonitor.terminalBatch.okBtn') }}</el-button>
    </span>
    <!-- 选择车辆 -->
    <select-obd-dialog
      :visibles.sync="selectCarVisibles"
      :data="selectCarList"
      @select-complete="selectCarComplete"
    />
    <!-- 导入 -->
    <import-dialog
      ref="importDialog"
      action="api/batchremotesetting/obdImport"
      :template-url="'file/upload/template/TerminalImportForCommandSetting.xlsx'"
      :append-to-body="true"
      :visibles.sync="importVisible"
      @upload-success="importCarComplete"
    />
  </el-dialog>
</template>

<script>
// 混入
import selectObdDialog from "./selectObdDialog"
import importDialog from "@/components/importDialog"
// import selectCommondDialog from './selectCommondDialog'
import {
  createCommond,
  getHistoricalVersion,
  getUpgrade,
} from "@/api/carMonitor/terminalBatch"
import { duplicateRemoval } from "@/utils/base"
import { tableStyle } from "@/mixins/tableStyle"

// request
export default {
  name: "AddTaskDialog",
  components: { selectObdDialog, importDialog },
  mixins: [tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const validatefaultcode = (rule, value, cb) => {
      if (value === "" || value === undefined) {
        return cb(new Error(this.$t("carMonitor.terminalBatch.tasknameTips")))
      }
    }
    const validateCar = (rule, value, cb) => {
      if (this.selectCarList.length === 0) {
        return cb(new Error(this.$t("carMonitor.terminalBatch.selectCarTips")))
      }
    }
    const validateFileVersion = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t("carMonitor.terminalBatch.error.message1")))
      }
    }
    const validateFileName = (rule, value, cb) => {
      if (!this.formInfo.fileName) {
        return  cb(new Error(this.$t("carMonitor.terminalBatch.error.message2")))
      }
    }
    const validatehistoryVersion = (rule, value, cb) => {
      if (!value) {
        return  cb(new Error(this.$t("carMonitor.terminalBatch.error.message3")))
      }
    }
    const validatesjtype = (rule, value, cb) => {
      if (!value) {
        return  cb(new Error(this.$t("carMonitor.terminalBatch.error.message5")))
      }
    }

    return {
      formInfo: {
        operationname: "",
        remark: "",
      },
      total: 0,
      list: [],
      listLoading: false,
      selectCarList: [],
      selectCarVisibles: false,
      selectCommondVisible: false,
      importVisible: false,
      selectCommond: {},
      rulesCenter: {
        operationname: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validatefaultcode,
          },
        ],
        car: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validateCar,
          },
        ],
        fileName: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validateFileName,
          },
        ],
        fileVersion: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validateFileVersion,
          },
        ],
        historicalVersion: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validatehistoryVersion,
          },
        ],
        type: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validatesjtype,
          },
        ],
      },
      commandInfo: {},
      sjList:[
        {text:this.$t("carMonitor.terminalBatch.sjtype1"), value:'1'},
        {text:this.$t("carMonitor.terminalBatch.sjtype2"), value:'0'}
      ],
      selectionList: [],
      fileList: [],
      fileResult: [],
      historyVersionList: [],
      isHistory: false,
      commandid: "",
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this._getHistoricalVersion()
        this._getUpgrade()
      }
    },
  },
  computed: {
    selectCommondStr() {
      return this.selectCommond.packetname
    },
    token() {
      return this.$store.getters.token
    },
    lang() {
      return this.$store.getters.language
    },
    baseApi() {
      return process.env.VUE_APP_BASEURL
    },
  },
  created() {},
  methods: {
    _getHistoricalVersion() {
      getHistoricalVersion().then(({ data }) => {
        if (data.code === 0) {
          this.historyVersionList = data.data || []
        }
      })
    },
    _getUpgrade() {
      getUpgrade().then(({ data }) => {
        if (data.code === 0) {
          this.commandid = data.data && data.data[0].oid
        }
      })
    },
    handleClose(tag) {
      this.selectCarList.splice(this.selectCarList.indexOf(tag), 1)
    },
    selectCarComplete(e) {
      this.selectCarList = duplicateRemoval([...e], "barcode")
      this.$refs.carform.validate((vaild) => {
        if (!vaild) {
          // check2 = false
        }
      })
    },
    importCarComplete(e) {
      const resultSuccess = e.successList || []
      const successList = resultSuccess.map((item) => {
        return { barcode: item }
      })
      this.selectCarList = duplicateRemoval(
        [...this.selectCarList, ...successList],
        "barcode"
      )
      this.$refs.importDialog.closeDialog()
    },
    handleClear() {
      this.selectCarList = []
    },
    selectCommondComplete(e) {
      this.selectCommond = { ...e }
    },
    // 重置数据
    restData() {
      this.total = 0
      this.selectCarList = []
      this.selectCommond = {}
      this.formInfo = {}
      this.commandInfo = {}
      this.selectionList = []
      this.fileResult = []
      this.isHistory = false
      //   this.commandid = ''
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit("update:visibles", false)
    },
    // 点击取消
    handleCancel() {
      this.closeDialog()
    },
    submitForm() {
      let check1 = true
      this.$refs.taskform.validate((vaild) => {
        if (!vaild) {
          check1 = false
        }
      })
      let check2 = true
      this.$refs.carform.validate((vaild) => {
        if (!vaild) {
          check2 = false
        }
      })

      if (!check1 || !check2) {
        return
      }

      const { fileVersion, remark, type } = this.commandInfo
      const strcommandparams = []
      strcommandparams[0] = {
        param: {
          fileVersion: fileVersion,
          remark: remark
        },
        commandid: this.commandid,
        commandtype: 1,
      }
      if (!this.isHistory) {
        let check3 = true
        this.$refs.commandForm.validate((vaild) => {
          if (!vaild) {
            check3 = false
          }
        })
        let check4 = true
        this.$refs.fileName.validate((vaild) => {
          if (!vaild) {
            check4 = false
          }
        })
        if (!check3 || !check4) return
        const { FILEPATH, NEWNAME, OLDNAME } = this.fileResult[0]
        strcommandparams[0].param = {
          ...strcommandparams[0].param,
          ...{
            newName: NEWNAME,
            oldName: OLDNAME,
            filePath: FILEPATH,
          },
        }
      } else {
        let check5 = true
        this.$refs.history.validate((vaild) => {
          if (!vaild) {
            check5 = false
          }
        })
        if (!check5) return
        const result = this.historyVersionList.find((item) => {
          return item.historicalVersion === this.commandInfo.historicalVersion
        })
        // console.log(result)
        const { filepath, oldname, version } = result
        strcommandparams[0].param = {
          ...strcommandparams[0].param,
          ...{
            oldName: oldname,
            filePath: filepath,
            fileVersion :version,
          },
        }
      }
      const postData = {
        operationname: this.formInfo.operationname,
        commandname: this.selectCommond.packetname,
        packetid: this.selectCommond.oid,
        caridlist: this.selectCarList.map((obj) => obj.barcode).join(","),
        remark: this.formInfo.remark,
        maxexetimes: "3",
        strcommandparams: JSON.stringify(strcommandparams),
        type: type
      }
      if (this.selectCarList.length === 0) {
        this.$message.error({
          message: this.$t("carMonitor.terminalBatch.selectCarTips"),
          duration: 2 * 1000,
        })
        return
      }
      createCommond(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t("carMonitor.terminalBatch.addSuccess"),
            duration: 2 * 1000,
          })
          this.$emit("add-complete")

          this.closeDialog()
        }
      })
    },
    // 上传之前得验证
    beforeupload(file) {
      this.uid = file.uid
    },
    // 文件状态改变时触发
    fileChange(file, fileList) {
      // 获取最新的文件
      this.fileList = fileList.slice(-1)
      if (this.fileList[0].name.indexOf(".bin") > -1) {
        this.formInfo.fileName = file.name
        this.$refs.upload.submit()
      } else {
        this.$message.error({
          message: this.$t("carMonitor.terminalBatch.error.message4"),
          duration: 2000,
        })
      }
    },
    // 导入车辆上传成功钩子
    fileSuccess(response) {
      if (response.code === 0 && response.data) {
        this.$notify({
          title: this.$t("carMonitor.terminalCommand.success"),
          message: this.$t("carMonitor.terminalCommand.uploadSuccess"),
          type: "success",
          duration: 3000,
        })
        if (response.code === 0) {
          try {
            const result = JSON.parse(response.data)
            this.fileResult = result || []
            // postData.newFileName = result[0].NEWNAME
            // postData.oldFileName = result[0].OLDNAME
            // postData.filePath = result[0].FILEPATH
          } catch (err) {
            console.log(err)
          }
        }
      } else {
        this.$message.error({
          message: response.message,
          duration: 2 * 1000,
        })
      }
      this.restStatus()
    },
    // 导入车辆上传失败钩子
    // eslint-disable-next-line no-unused-vars
    fileError(response, file, fileListt) {
      this.restStatus()
    },
    restStatus() {
      this.fileList = []
      //   this.uploadloading.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.search_list {
  padding-top: 0;
}
.fl {
  float: left;
}
.car-tag {
  width: calc(100%);
  height: 100px;
  border: 1px dashed #ddd;
  padding: 3px;
  .numberPlate {
    margin: 5px 0;
    span {
      font-weight: bold;
    }
  }
}
.car-add-btn {
  float: right;
  margin-top: 10px;
  .el-button + .el-button {
    margin: 20px 0 0;
  }
}
</style>
